import script from "./HeadertoConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadertoConfig.vue?vue&type=script&setup=true&lang=js"

import "./HeadertoConfig.vue?vue&type=style&index=0&id=96f2bb2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96f2bb2c"]])

export default __exports__